import { red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: '#212553', // Traditional Deltatre Dark Blue
        },
        secondary: {
            main: '#F75258', // Traditional Deltatre Red
        },
        error: {
            main: red.A400,
        },
    },
});

export default theme;
